import {  lazy } from 'react';

// project-imports
import MainLayout from 'layout/MainLayout';
// import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';
import HRRoutes from "./HRRoutes";
import CRMRoutes from "./CRMRoutes";
import ProjectRoutes from "./ProjectRoutes";
// import Attendance from "./Attendance";
import Setting from "./Setting";
import Profile from "./Profile";
import Accounts from './Accounts';
import Reports from './Reports';


// import AuthGuard from 'utils/route-guard/AuthGuard';

// render - dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));



// ==============================|| contacts ||============================== //

const CustomerList = Loadable(lazy(() => import('pages/contacts/customers/customers')));
const SupplierList = Loadable(lazy(() => import('pages/contacts/suppliers/suppliers')));



// ==============================|| MAIN ROUTES ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        // <AuthGuard>
          <MainLayout />
        // </AuthGuard>
      ),
      children: [
        {
          path: 'dashboard',
          element: <DashboardDefault />
          
          // children: [
          //   {
          //     path: 'default',
          //     element: <DashboardDefault />
          //   },
            // {
            //   path: 'analytics',
            //   element: <DashboardAnalytics />
            // }
          // ]
        },
        ProjectRoutes,
        {
          path: 'contacts',
          // element: <ProjectList />,
          children: [
            {
              path: 'customers',
              element: <CustomerList />
            },
            {
              path: 'suppliers',
              element: <SupplierList />
            },
            
          ]
        },
       
        CRMRoutes,
        HRRoutes,
        Profile,
        Accounts,
        Reports,
        Setting
      ]
    },
   
  ]
};

export default MainRoutes;
